<template>
    <div class="wrap">
        <header class="header header--intro">
            <div class="header__container">
                <div class="header__row">
                    <div class="logo">
                        <div class="logo__container">
                            <div class="logo__row">
                                <h1 class="logo__logo" :class="{'logo__logo logo__logo--black' : this.isPopup} " aria-label="my Protein TEST"></h1>
                                <button @click="popup()" :class="{'rotate-down' : this.isPopup}" type="button" class="logo__trigger" aria-controls="logoLayer" aria-label="버튼" aria-haspopup="true" aria-expanded="false"></button>
                                <div :style=" {display : this.isPopup? 'block' : 'none'}" v-if="this.isPopup" role="menu" id="logoLayer" class="logo__layer">
                                    <a @click="moveAmwayPage()" style="cursor: pointer;" role="menuitem" aria-label="Amway"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <button type="button" class="share" aria-haspopup="dialog" aria-label="공유" data-micromodal-trigger="shareSns"></button>
                </div>
            </div>
        </header>

        <div class="contents">
            <div class="contents__contents contents__contents--intro">
                <div class="intro-swiper">
                    <div class="intro-swiper__swiper swiper-container">
                        <div class="swiper-wrapper">
                            <div class="intro-swiper__slide intro-swiper__slide--first swiper-slide">
                                <p class="title">
                                    내가 바로<br>
                                    단백질 전문가
                                </p>
                                <p class="desc">
                                    백세 건강을 위해 내 몸에 꼭 필요한 단백질,<br>
                                    어디까지 알고 계신가요?<br>
                                    단백질에 대한 모든 것을 알려 드릴게요!
                                </p>
                                <div>
                                    <!-- <vLottiePlayer :animationData="require('./assets/lottie/intro01.json')" background="transparent" speed="0.5" style="width: 100%; height: 100%;" loop autoplay></vLottiePlayer> -->
                                    <vLottiePlayer v-if="this.swiperIndex < 3" :animationData="require('./assets/lottie/intro01.json')" background="transparent" speed="1" style="width: 100%; height: 100%;" loop autoplay></vLottiePlayer>

                                </div>
                            </div>
                            <div class="intro-swiper__slide intro-swiper__slide--second swiper-slide">
                                <p class="title">
                                    스스로 알아보는<br>
                                    단백질 부족 신호
                                </p>
                                <p class="desc">
                                    단백질이 부족하면 우리 몸은<br>
                                    &lsquo;위험 신호&rsquo;를 보냅니다. 이런 증상이 있다면<br>
                                    단백질 꼭 챙겨 드셔야 해요.
                                </p>
                                <div>
                                    <vLottiePlayer :animationData="require('./assets/lottie/intro02.json')" background="transparent" speed="1" style="width: 100%; height: 100%;" loop autoplay></vLottiePlayer>
                                    <!-- <lottie-player src="../assets/lottie/intro02.json" background="transparent" speed="1" style="width: 100%; height: 100%;" loop autoplay></lottie-player> -->
                                </div>
                            </div>
                            <div class="intro-swiper__slide intro-swiper__slide--third swiper-slide">
                                <p class="title">
                                    내 몸이 필요로 하는<br>
                                    하루 단백질량은?
                                </p>
                                <p class="desc">
                                    단백질은 근육을 이루는 주요 구성 성분으로,<br>
                                    근육을 만드는 필수 재료예요! 효율적인<br>
                                    근육 증가를 위해 충분히 단백질을 섭취해주세요.</p>
                                <div>
                                    <vLottiePlayer :animationData="require('./assets/lottie/intro03.json')" background="transparent" speed="1" style="width: 100%; height: 100%;" loop autoplay></vLottiePlayer>
                                    <!-- <lottie-player src="../assets/lottie/intro03.json" background="transparent" speed="1" style="width: 100%; height: 100%;" loop autoplay></lottie-player> -->
                                </div>
                            </div>
                        </div>
                        <div class="swiper-pagination"></div>
                        <div class="swiper-button-prev"></div>
                        <div class="swiper-button-next"></div>
                    </div>
                </div>
                <div class="button">
                    <div class="button__row">
                        <a href="/quiz" class="button__item button__item--secondary">시작하기</a>
                    </div>
                </div>
            </div>
        </div>
        
        <div id="shareSns" class="modal" aria-hidden="true">
            <div class="modal__overlay" tabindex="-1" data-micromodal-close="shareSns">
                <div role="dialog" class="modal__body" aria-modal="true" aria-labelledby="shareSnsTitle">
                    <header class="modal__header">
                        <p id="shareSnsTitle" class="modal__title">SNS 공유</p>
                        <button type="button" class="close" aria-label="닫기" data-micromodal-close="shareSns"></button>
                    </header>
                    <div class="modal__contents">
                        <div class="sns-list">
                            <div class="sns-list__list">
                                <a href="#;" id="kakao-btn" @click="shareSns('kakaoTalk')" class="sns-list__item sns-list__item--kakaoTalk">
                                    <i></i>
                                    <p>카카오톡</p>
                                </a>
                                
                                <a href="#" @click="shareSns('kakaostory')" class="sns-list__item sns-list__item--kakaostory">
                                    <i></i>
                                    <p>카카오스토리</p>
                                </a>
                                
                                <a href="#" @click="shareSns('facebook')" class="sns-list__item sns-list__item--facebook">
                                    <i></i>
                                    <p>페이스북</p>
                                </a>
                                <a href="#" @click="shareSns('twitter')" class="sns-list__item sns-list__item--twitter">
                                    <i></i>
                                    <p>트위터</p>
                                </a>
                                <a href="#" @click="shareSns('naverBand')" class="sns-list__item sns-list__item--band">
                                    <i></i>
                                    <p>밴드</p>
                                </a>
                                <a href="#" @click="copyEventURL('currentURL')" class="sns-list__item sns-list__item--copy">
                                    <i></i>
                                    <p>URL 복사</p>
                                </a>
                            </div>
                            <div class="sns-list__noti">
                                <em>SNS 공유안내</em>
                                <p>
                                    한국암웨이의 amway.co.kr에서 서비스 되는 일체의 콘텐츠에 대한 지적 재산권은 한국암웨이㈜에 있으며, 임의로 자료를 수정/변경하여 사용하거나, 기타 개인의 영리 목적으로 사용할 경우에는 지적 재산권 침해에 해당하는 사안으로, 그 모든 법적 책임은 콘텐츠를 불법으로 남용한 개인 또는 단체에 있습니다.
                                    <br><br>
                                    모든 자료는 원저작자의 요청이나 한국암웨이의 사정에 따라 예고 없이 삭제될 수 있습니다.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import MicroModal from 'micromodal';
import Swiper from 'swiper';
import VueLottiePlayer from 'vue-lottie-player'
import kakao from './assets/js/kakao.min.js'

export default {
	name : 'myprotein-index',
    data () {
        return {
            isPopup : false,
            swiperIndex : 1
        }
    },
    
	components: {
		vLottiePlayer: VueLottiePlayer
	},
	methods: {
        // 상단메뉴 팝업
        popup(){
			this.isPopup = !this.isPopup
		},
        // 상단메뉴 Amway 
        moveAmwayPage () {
            window.location.href = process.env.AMWAY_ROOT_URL
        },
        // 공유하기
        shareSns (snsInfo) {
            switch(snsInfo){
                case 'kakaoTalk' :
                    this.shareKakaoTalk()
                    break;
                case 'kakaostory':
                    window.open('https://story.kakao.com/s/share?url=' + process.env.EVENT_URL + '/myprotein');
                    console.log("카카오스토리 공유.")
                    break

                case 'facebook':
                    window.open('https://www.facebook.com/sharer/sharer.php?u=' + process.env.EVENT_URL + '/myprotein');
                    console.log("페이스북 공유.")
                    break

                case 'twitter':
                    window.open('https://twitter.com/intent/tweet?text=' + process.env.EVENT_URL + '/myprotein');
                    console.log("트위터 공유.")
                    break

                case 'naverBand':
                    window.open('https://band.us/plugin/share?body=' + process.env.EVENT_URL + '/myprotein');
                    console.log("네이버밴드 공유.")
                    break
            }
        },
        // 공유하기 - URL복사
        copyEventURL () {
            let url = '';
            const textarea = document.createElement("textarea");
            document.body.appendChild(textarea);
            url = window.document.location.href;
            textarea.value = url;
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
        },
        // 카카오톡 공유하기
        shareKakaoTalk () {
            Kakao.Link.sendDefault({
                objectType : 'feed',
                content : {
                    title: '한국암웨이',
                    description: '마이 푸로틴 테스트',
                    imageUrl : process.env.PROTEIN_IMAGEURL,
                    link :{
                        mobileWebUrl : process.env.EVENT_URL + '/myprotein',
                        webUrl : process.env.EVENT_URL + '/myprotein'
                    }
                }
            })
        },

		// Swiper 초기화
		initIntroSwiper() {
			const swiper = new Swiper('.intro-swiper__swiper', {
				autoplay: {
					delay: 5000,
					disableOnInteraction: false,
				},
				fadeEffect: {
					crossFade: true,
				},
				effect: 'fade',
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				// loop: true,
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
				},
				speed: 400,
			});
            // Swiper 슬라이더 감지
            swiper.on('slideChange', () => {
                this.swiperIndex ++
                if(this.swiperIndex == 4) {
                    this.swiperIndex = 1
                }
            })
		},
		// Modal 초기화
		microModal () {
			MicroModal.init({
				openClass: 'modal--opened',
				disableScroll: true,
				disableFocus: false,
			})
		}
	},
	mounted() {
		// Swiper & Modal 초기화
        try {
            Kakao.init(process.env.KAKAO_AUTH_KEY)
        } catch (err) {
            console.log("Kakao Talk Initialize Error")
        }
		this.initIntroSwiper();
		this.microModal();
	},
}
</script>
<style>
@import './assets/css/amway.css';

.rotate-down {
	transform: rotate(-270deg) !important
}

</style>


// WEBPACK FOOTER //
// src/views/myprotein-test/index.vue